// src/autoSearchShowcase.js - ПОЛНАЯ ИСПРАВЛЕННАЯ ВЕРСИЯ БЕЗ БАГОВ

class AutoSearchShowcase {
  constructor(map) {
    this.map = map;
    this.isRunning = false;
    this.isRecording = false;
    this.isPaused = false;
    this.isCaching = false;
    this.currentLocationIndex = 0;
    this.visitedLocations = [];
    this.mediaRecorder = null;
    this.recordedChunks = [];
    this.isCached = false;
    this.compositeCanvas = null;
    this.compositeContext = null;
    
    // 🎯 ЛОКАЦИИ ДЛЯ АВТОПОИСКА
    this.searchLocations = [
      "30 Rockefeller Plaza",
      "New York"
    ];
    
    // ⚙️ НАСТРОЙКИ - УВЕЛИЧЕННЫЕ ЗАДЕРЖКИ
    this.settings = {
      typingSpeed: 100,
      searchDelay: 500,        // ✅ Увеличено до 5 секунд
      flightDuration: 6000,
      transitionTime: 3000,
      videoQuality: 'web',
      postLocationDelay: 2000,
      cachingDelay: 550
    };
    
    // 🎥 НАСТРОЙКИ ВИДЕО
    this.videoSettings = {
      mobile: { 
        fps: 30, 
        bitrate: 2000000, 
        width: 720, 
        height: 480
      },
      web: { 
        fps: 30, 
        bitrate: 4000000, 
        width: 1280, 
        height: 720
      },
      hd: { 
        fps: 30, 
        bitrate: 8000000, 
        width: 1920, 
        height: 1080
      }
    };
  }

  // 🗄️ ПРЕДВАРИТЕЛЬНОЕ КЭШИРОВАНИЕ
  async startPreCaching() {
    if (this.isCaching) {
      console.warn('⚠️ Кэширование уже выполняется');
      return;
    }

    console.log('🗄️ Запуск предварительного кэширования всех локаций...');
    
    this.isCaching = true;
    this.isCached = false;
    
    this.showCachingIndicator();
    
    try {
      await this.preloadAllLocations();
      this.isCached = true;
      console.log('✅ Предварительное кэширование завершено успешно!');
      this.showCacheCompleteNotification();
    } catch (error) {
      console.error('❌ Ошибка кэширования:', error);
      this.showCacheErrorNotification();
    } finally {
      this.isCaching = false;
      this.hideCachingIndicator();
    }
  }

  showCachingIndicator() {
    const indicator = document.createElement('div');
    indicator.id = 'caching-indicator';
    indicator.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 15000;
      background: #FF9500;
      color: white;
      padding: 12px 20px;
      border-radius: 25px;
      font-size: 14px;
      font-weight: bold;
      box-shadow: 0 4px 15px rgba(255, 149, 0, 0.4);
      animation: cachePulse 2s infinite;
    `;
    
    indicator.innerHTML = '🗄️ Предварительное кэширование...';
    
    const style = document.createElement('style');
    style.id = 'cache-animation';
    style.textContent = `
      @keyframes cachePulse {
        0% { opacity: 1; transform: translateX(-50%) scale(1); }
        50% { opacity: 0.8; transform: translateX(-50%) scale(1.02); }
        100% { opacity: 1; transform: translateX(-50%) scale(1); }
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(indicator);
  }

  updateCachingProgress(current, total, location) {
    let indicator = document.getElementById('caching-indicator');
    if (indicator) {
      const percent = Math.round((current / total) * 100);
      indicator.innerHTML = `
        🗄️ Кэширование ${current}/${total} (${percent}%) - ${location}
      `;
    }
  }

  hideCachingIndicator() {
    const indicator = document.getElementById('caching-indicator');
    if (indicator) indicator.remove();
    
    const style = document.getElementById('cache-animation');
    if (style) style.remove();
  }

  showCacheCompleteNotification() {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20000;
      background: #34C759;
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      font-weight: bold;
      box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    `;
    notification.innerHTML = '✅ Кэширование завершено! Можно начинать запись';
    document.body.appendChild(notification);
    
    setTimeout(() => notification.remove(), 5000);
  }

  showCacheErrorNotification() {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20000;
      background: #FF453A;
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      font-weight: bold;
      box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    `;
    notification.innerHTML = '❌ Ошибка кэширования. Попробуйте еще раз';
    document.body.appendChild(notification);
    
    setTimeout(() => notification.remove(), 5000);
  }

  async preloadAllLocations() {
    console.log('🗄️ Предварительное кэширование всех локаций...');
    
    const mockCoordinates = {
      "30 Rockefeller Plaza": [-73.9787, 40.7589],
      // "Baker Street 221b": [-0.1586, 51.5238], 
      // "Trafalgar Square": [-0.1278, 51.5080],
      "New York": [-74.0060, 40.7128]
      // "Miami": [-80.1918, 25.7617], 
      // "Madrid": [-3.7038, 40.4168],
      // "Berlin": [13.4050, 52.5200],
      // "France": [2.2137, 46.2276],
      // "United Kingdom": [-3.4360, 55.3781]
    };

    for (let i = 0; i < this.searchLocations.length; i++) {
      const location = this.searchLocations[i];
      
      if (!this.isCaching) break;
      
      this.updateCachingProgress(i + 1, this.searchLocations.length, location);
      
      const coords = mockCoordinates[location];
      if (coords) {
        console.log(`🗄️ Кэширование: ${location}`);
        await this.preloadLocationTiles(coords, location);
        await this.delay(200);
      }
    }
    
    console.log('✅ Предварительное кэширование завершено');
  }

  async preloadLocationTiles(coordinates, locationName) {
    const [lng, lat] = coordinates;
    
    let targetZoom = 15;
    const name = locationName.toLowerCase();
    
    if (name.includes('rockefeller') || name.includes('30 rockefeller')) {
      targetZoom = 15.5;
    } else if (name.includes('plaza') || name.includes('street')) {
      targetZoom = 16;
    } else if (name.includes('square')) {
      targetZoom = 15.5;
    } else if (name.match(/^(new york|miami|madrid|berlin)$/)) {
      targetZoom = 11;
    } else if (name.match(/^(france|united kingdom)$/)) {
      targetZoom = 6;
    }
    
    const currentCenter = this.map.getCenter();
    const currentZoom = this.map.getZoom();
    const currentPitch = this.map.getPitch();
    const currentBearing = this.map.getBearing();
    
    const radius = 0.15;
    const cachePoints = [];
    
    cachePoints.push([lng, lat]);
    
    for (let x = -4; x <= 4; x++) {
      for (let y = -4; y <= 4; y++) {
        if (x === 0 && y === 0) continue;
        cachePoints.push([
          lng + (x * radius / 4),
          lat + (y * radius / 4)
        ]);
      }
    }
    
    for (let ring = 1; ring <= 3; ring++) {
      for (let i = 0; i < 32; i++) {
        const angle = (i / 32) * Math.PI * 2;
        cachePoints.push([
          lng + Math.cos(angle) * radius * ring / 3,
          lat + Math.sin(angle) * radius * ring / 3
        ]);
      }
    }
    
    for (const point of cachePoints) {
      if (!this.isCaching) break;
      
      this.map.setCenter(point);
      this.map.setZoom(targetZoom);
      this.map.triggerRepaint();
      
      await this.delay(this.settings.cachingDelay);
    }
    
    for (let zoom = Math.max(targetZoom - 4, 2); zoom <= Math.min(targetZoom + 4, 18); zoom++) {
      if (!this.isCaching) break;
      
      this.map.setCenter([lng, lat]);
      this.map.setZoom(zoom);
      this.map.triggerRepaint();
      
      await this.delay(this.settings.cachingDelay * 2);
    }
    
    this.map.setCenter(currentCenter);
    this.map.setZoom(currentZoom);
    this.map.setPitch(currentPitch);
    this.map.setBearing(currentBearing);
    this.map.triggerRepaint();
    
    console.log(`✅ Тщательное кэширование завершено для: ${locationName}`);
  }

  stopCaching() {
    if (this.isCaching) {
      console.log('⏹️ Остановка кэширования');
      this.isCaching = false;
      this.hideCachingIndicator();
      this.showWarningNotification('⏹️ Кэширование остановлено');
    }
  }

  showWarningNotification(message) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20000;
      background: #FF9500;
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      font-weight: bold;
      box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    `;
    notification.innerHTML = message;
    document.body.appendChild(notification);
    
    setTimeout(() => notification.remove(), 6000);
  }

  // 🚀 ГЛАВНАЯ ФУНКЦИЯ ЗАПУСКА
  async startAutoSearchTour(quality = 'web') {
    if (this.isRunning) {
      console.warn('⚠️ Автопоиск уже запущен');
      return;
    }

    if (!this.isCached) {
      console.warn('⚠️ Сначала выполните предварительное кэширование!');
      this.showWarningNotification('⚠️ Сначала нажмите "Кэширование", затем запускайте съемку!');
      return;
    }
    
    console.log(`🚀 Запуск записи области карты автопоиска (${quality})`);
    
    this.isRunning = true;
    this.isRecording = false;
    this.currentLocationIndex = 0;
    this.visitedLocations = [];
    this.settings.videoQuality = quality;
    
    this.hideUIElementsForVideo();
    await this.delay(800);
    
    const recordingStarted = await this.startSimpleMapRecording(quality);
    if (!recordingStarted) {
      this.showUIElements();
      this.isRunning = false;
      return;
    }
    
    this.showRecordingIndicator();
    
    for (let i = 0; i < this.searchLocations.length && this.isRunning; i++) {
      this.currentLocationIndex = i;
      const location = this.searchLocations[i];
      
      console.log(`📍 ${i + 1}/${this.searchLocations.length}: Запись "${location}"`);
      
      this.updateVideoProgress(i + 1, this.searchLocations.length, location);
      
      try {
        await this.processLocationForRecording(location);
        
        
      } catch (error) {
        console.error(`❌ Ошибка обработки локации "${location}":`, error);
      }
    }
    
    // if (this.isRunning && this.visitedLocations.length > 1) {
    //   await this.createFinalTransition();
    // }
    
    this.hideRecordingIndicator();
    this.stopVideoRecording();
    setTimeout(() => {
      this.showUIElements();
    }, 1000);
    
    this.isRunning = false;
    console.log(`✅ Запись автопоиска завершена! Обработано ${this.visitedLocations.length} локаций`);
  }

  async startSimpleMapRecording(quality = 'web') {
    try {
      console.log(`📹 Начало простой записи canvas карты: ${quality}`);
      
      const settings = this.videoSettings[quality];
      const mapCanvas = this.map.getCanvas();
      
      const mapStream = mapCanvas.captureStream(settings.fps);
      
      const options = {
        mimeType: 'video/webm;codecs=vp8',
        videoBitsPerSecond: settings.bitrate
      };
      
      this.mediaRecorder = new MediaRecorder(mapStream, options);
      this.recordedChunks = [];
      
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };
      
      this.mediaRecorder.onstop = () => {
        this.saveVideoFile(quality);
      };
      
      this.mediaRecorder.start(1000);
      this.isRecording = true;
      
      console.log(`✅ 📹 Простая запись canvas карты началась! Качество: ${quality}`);
      return true;
      
    } catch (error) {
      console.error('❌ Ошибка начала записи canvas карты:', error);
      this.showWarningNotification('❌ Ошибка начала записи. Попробуйте еще раз.');
      return false;
    }
  }

  // ✅ ИСПРАВЛЕННАЯ ОБРАБОТКА ЛОКАЦИИ С FALLBACK
  async processLocationForRecording(locationQuery) {
    this.showTypingStatus(`Ввод: "${locationQuery}"`);
    
    try {
      // ✅ ПОЛНЫЙ ВВОД ТЕКСТА
      await this.simulateTypingCombined(locationQuery);
      
      this.showTypingStatus('Принудительное показ dropdown...');
      
      // ✅ ПРИНУДИТЕЛЬНОЕ ПОКАЗ DROPDOWN
      await this.forceDropdownShow();
      
      this.showTypingStatus('Ожидание результатов...');
      
      // ✅ ЖДЕМ РЕЗУЛЬТАТЫ
      const hasResults = await this.waitForSearchResults();
      
      if (!hasResults) {
        console.warn(`⚠️ Результаты не найдены для "${locationQuery}", используем мокк-координаты`);
        
        // ✅ ВСЕГДА ИСПОЛЬЗУЕМ МОКК-КООРДИНАТЫ ЕСЛИ DROPDOWN НЕ РАБОТАЕТ
        const mockPlace = this.getMockCoordinatesForQuery(locationQuery);
        if (mockPlace) {
          console.log(`🔄 Используем мокк-координаты для "${locationQuery}"`);
          this.showTypingStatus(`Пролет к: ${mockPlace.name} (мокк)`);
          await this.flyToLocation(mockPlace);
          
          this.visitedLocations.push({
            query: locationQuery,
            place: mockPlace,
            timestamp: Date.now()
          });
          
          console.log(`✅ Локация "${locationQuery}" записана с мокк-координатами`);
          await this.delay(this.settings.postLocationDelay);
        }
        this.hideTypingStatus();
        return;
      }
      
      this.showTypingStatus('Выбор первого результата...');
      const selectedPlace = await this.clickFirstResult();
      
      if (selectedPlace && selectedPlace.coordinates) {
        this.showTypingStatus(`Пролет к: ${selectedPlace.name}`);
        await this.flyToLocation(selectedPlace);
        
        this.showTypingStatus('Финализация...');
        await this.delay(800);
        
        this.visitedLocations.push({
          query: locationQuery,
          place: selectedPlace,
          timestamp: Date.now()
        });
        
        console.log(`✅ Локация "${locationQuery}" записана успешно`);
        await this.delay(this.settings.postLocationDelay);
        
      } else {
        console.warn(`⚠️ Не найдена валидная локация для "${locationQuery}"`);
        
        // ✅ Fallback на мокк-координаты
        const mockPlace = this.getMockCoordinatesForQuery(locationQuery);
        if (mockPlace) {
          console.log(`🔄 Fallback на мокк-координаты для "${locationQuery}"`);
          await this.flyToLocation(mockPlace);
          
          this.visitedLocations.push({
            query: locationQuery,
            place: mockPlace,
            timestamp: Date.now()
          });
        }
      }
      
    } catch (error) {
      console.error(`❌ Ошибка записи локации "${locationQuery}":`, error);
      
      // ✅ Аварийный fallback
      const mockPlace = this.getMockCoordinatesForQuery(locationQuery);
      if (mockPlace) {
        console.log(`🔄 Аварийный fallback на мокк-координаты для "${locationQuery}"`);
        await this.flyToLocation(mockPlace);
        
        this.visitedLocations.push({
          query: locationQuery,
          place: mockPlace,
          timestamp: Date.now()
        });
      }
    } finally {
      this.hideTypingStatus();
    }
  }

  hideUIElementsForVideo() {
    const elementsToHide = [
      '#tour-controls',
      '#auto-search-controls',
      '.maplibregl-ctrl-top-left .maplibregl-ctrl-group',
      '.maplibregl-ctrl-top-right .maplibregl-ctrl-group',
      '.maplibregl-ctrl-bottom-left .maplibregl-ctrl-group', 
      '.maplibregl-ctrl-bottom-right .maplibregl-ctrl-group',
      '.h3-controls'
    ];

    this.hiddenElements = [];

    elementsToHide.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (el && el.style.display !== 'none') {
          if (el.classList.contains('demo-search-container') || 
              el.classList.contains('geosearch-container') ||
              el.closest('.demo-search-container') ||
              el.closest('.geosearch-container')) {
            return;
          }
          
          this.hiddenElements.push({
            element: el,
            originalDisplay: el.style.display
          });
          el.style.display = 'none';
        }
      });
    });

    console.log(`🙈 Скрыто ${this.hiddenElements.length} элементов управления (поиск остался видимым)`);
  }

  showRecordingIndicator() {
    const indicator = document.createElement('div');
    indicator.id = 'video-recording-indicator';
    indicator.style.cssText = `
      position: fixed;
      top: 20px;
      left: 20px;
      z-index: 15000;
      background: #FF453A;
      color: white;
      padding: 8px 15px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: bold;
      box-shadow: 0 2px 10px rgba(255, 69, 58, 0.3);
      animation: pulse 2s infinite;
    `;
    
    indicator.innerHTML = '🔴 REC CANVAS';
    
    const style = document.createElement('style');
    style.id = 'recording-animation';
    style.textContent = `
      @keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.7; transform: scale(1.05); }
        100% { opacity: 1; transform: scale(1); }
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(indicator);
  }

  updateVideoProgress(current, total, location) {
    let progressDiv = document.getElementById('video-progress-indicator');
    
    if (!progressDiv) {
      progressDiv = document.createElement('div');
      progressDiv.id = 'video-progress-indicator';
      progressDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 15000;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 10px 15px;
        border-radius: 8px;
        font-size: 12px;
        min-width: 200px;
        text-align: center;
      `;
      document.body.appendChild(progressDiv);
    }
    
    const percent = Math.round((current / total) * 100);
    progressDiv.innerHTML = `
      <div style="font-weight: bold; margin-bottom: 5px;">
        🤖 Автопоиск ${current}/${total} (${percent}%)
      </div>
      <div style="font-size: 10px; opacity: 0.8; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        📍 ${location}
      </div>
      <div style="background: #333; height: 4px; border-radius: 2px; margin-top: 5px;">
        <div style="background: #007AFF; height: 100%; width: ${percent}%; border-radius: 2px; transition: width 0.3s ease;"></div>
      </div>
    `;
  }

  showTypingStatus(message) {
    let statusDiv = document.getElementById('typing-status');
    
    if (!statusDiv) {
      statusDiv = document.createElement('div');
      statusDiv.id = 'typing-status';
      statusDiv.style.cssText = `
        position: fixed;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 15000;
        background: rgba(0, 122, 255, 0.9);
        color: white;
        padding: 8px 20px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
      `;
      document.body.appendChild(statusDiv);
    }
    
    statusDiv.innerHTML = message;
    statusDiv.style.display = 'block';
  }

  hideTypingStatus() {
    const statusDiv = document.getElementById('typing-status');
    if (statusDiv) {
      statusDiv.style.display = 'none';
    }
  }

  // ✅ ИСПРАВЛЕННЫЙ ПОИСК ПОЛЯ ВВОДА
  async findSearchInput() {
    console.log('🔍 Поиск поля ввода...');
    
    const directSelectors = [
      '.demo-search-container input',
      '.demo-search-input',
      'input.demo-search-input',
      '.geosearch-container input',
      '.geosearch-input',
      'input.geosearch-input',
      '#search-input',
      'input[type="search"]',
      'input[type="text"]',
      'input[placeholder*="search" i]',
      'input[placeholder*="place" i]',
      'input[placeholder*="find" i]',
      'input[placeholder*="address" i]',
      'input[name*="search" i]',
      'input[id*="search" i]'
    ];
    
    for (const selector of directSelectors) {
      const input = document.querySelector(selector);
      if (input && this.isValidSearchInput(input)) {
        console.log(`🔍 Найдено активное поле поиска: ${selector}`);
        return input;
      }
    }
    
    console.log('🔍 Активное поле не найдено, ищем placeholder...');
    
    const placeholderSelectors = [
      '.demo-search-placeholder',
      '.geosearch-placeholder',
      '[class*="placeholder"]'
    ];
    
    for (const selector of placeholderSelectors) {
      const placeholder = document.querySelector(selector);
      if (placeholder) {
        console.log(`🔍 Найден placeholder: ${selector}, активируем...`);
        
        placeholder.click();
        await this.delay(500);
        
        for (const inputSelector of directSelectors) {
          const input = document.querySelector(inputSelector);
          if (input && this.isValidSearchInput(input)) {
            console.log(`✅ Активирован input: ${inputSelector}`);
            return input;
          }
        }
      }
    }
    
    console.error('❌ Поле поиска не найдено!');
    return null;
  }

  isValidSearchInput(input) {
    if (!input) return false;
    
    if (input.classList.contains('h3-checkbox') || 
        input.classList.contains('h3-slider') ||
        input.className.includes('h3-') ||
        input.type === 'checkbox' ||
        input.type === 'radio' ||
        input.type === 'range' ||
        input.type === 'hidden' ||
        input.type === 'submit' ||
        input.type === 'button' ||
        input.type === 'reset') {
      return false;
    }
    
    const style = window.getComputedStyle(input);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    
    if (input.type === 'search' || input.type === 'text' || input.type === '') {
      if (input.placeholder && (
          input.placeholder.toLowerCase().includes('search') ||
          input.placeholder.toLowerCase().includes('find') ||
          input.placeholder.toLowerCase().includes('place') ||
          input.placeholder.toLowerCase().includes('address')
        )) {
        return true;
      }
      
      if (input.className && (
          input.className.includes('search') ||
          input.className.includes('geosearch') ||
          input.className.includes('demo-search')
        )) {
        return true;
      }
    }
    
    return false;
  }

  // ✅ КОМБИНИРОВАННЫЙ ВВОД ТЕКСТА
  async simulateTypingCombined(text) {
    console.log(`⌨️ Комбинированный ввод текста: "${text}"`);
    
    let searchInput = null;
    let attempts = 0;
    const maxAttempts = 10;
    
    while (!searchInput && attempts < maxAttempts) {
      searchInput = await this.findSearchInput();
      
      if (!searchInput) {
        console.log(`🔍 Попытка ${attempts + 1}/${maxAttempts}: поле не найдено, ждем...`);
        await this.delay(500);
        attempts++;
      }
    }
    
    if (!searchInput) {
      throw new Error('Поле поиска не найдено после всех попыток');
    }
    
    const reactSuccess = await this.simulateReactTyping(text, searchInput);
    
    if (reactSuccess) {
      console.log('✅ React метод сработал');
      return;
    }
    
    console.log('🔧 Переключаемся на симуляцию событий');
    await this.simulateTyping(text, searchInput);
  }

  async simulateReactTyping(text, searchInput = null) {
    console.log(`🔧 Альтернативный метод: Прямое взаимодействие с React для "${text}"`);
    
    if (!searchInput) {
      searchInput = await this.findSearchInput();
    }
    
    if (!searchInput) {
      throw new Error('Поле поиска не найдено');
    }
    
    console.log(`📊 Найдено поле: class="${searchInput.className}", placeholder="${searchInput.placeholder}"`);
    
    const reactFiber = this.getReactFiber(searchInput);
    if (reactFiber) {
      console.log('🔧 Найден React fiber, пытаемся обновить состояние напрямую');
      
      let component = reactFiber;
      while (component) {
        if (component.stateNode) {
          if (typeof component.stateNode.setState === 'function') {
            console.log('🔧 Найден компонент с setState, обновляем query');
            try {
              component.stateNode.setState({ 
                query: text,
                showDropdown: true 
              });
              await this.delay(1000);
              return true;
            } catch (error) {
              console.log('⚠️ Ошибка setState:', error.message);
            }
          }
          
          if (component.memoizedState) {
            console.log('🔧 Найдены React hooks, пытаемся обновить');
          }
        }
        component = component.return;
      }
    }
    
    return false;
  }

  // ✅ ИСПРАВЛЕННАЯ СИМУЛЯЦИЯ ВВОДА
  async simulateTyping(text, searchInput = null) {
    console.log(`⌨️ Медленный ввод текста: "${text}"`);
    
    if (!searchInput) {
      searchInput = await this.findSearchInput();
    }
    
    if (!searchInput) {
      throw new Error('Поле поиска не найдено');
    }
    
    searchInput.value = '';
    searchInput.focus();
    
    this.dispatchReactEvent(searchInput, 'focus');
    this.dispatchReactEvent(searchInput, 'focusin');
    this.dispatchReactEvent(searchInput, 'click');
    
    await this.delay(1000);
    
    // ✅ ПОЛНЫЙ ВВОД ТЕКСТА БЕЗ ПРЕРЫВАНИЯ
    for (let i = 0; i < text.length && this.isRunning; i++) {
      const char = text[i];
      
      console.log(`⌨️ Вводим символ: "${char}" (${i + 1}/${text.length})`);
      
      searchInput.value += char;
      
      await this.dispatchReactInputEvent(searchInput, char);
      this.forceReactUpdate(searchInput);
      
      const randomDelay = this.settings.typingSpeed + (Math.random() * 100 - 50);
      await this.delay(randomDelay);
    }
    
    await this.dispatchFinalReactEvents(searchInput);
    this.forceReactUpdate(searchInput);
    
    // ✅ ПРИНУДИТЕЛЬНО ПОКАЗЫВАЕМ DROPDOWN
    searchInput.focus();
    this.dispatchReactEvent(searchInput, 'focus');
    this.dispatchReactEvent(searchInput, 'focusin');
    
    await this.delay(1500);
    
    console.log(`✅ Ввод завершен: "${text}"`);
    console.log(`📊 Финальное значение поля: "${searchInput.value}"`);
  }

  // ✅ НОВАЯ ФУНКЦИЯ - ПРИНУДИТЕЛЬНОЕ ПОКАЗ DROPDOWN
  async forceDropdownShow() {
    console.log('🔧 Принудительное показ dropdown...');
    
    const searchInput = await this.findSearchInput();
    if (!searchInput) return;
    
    // ✅ ПРИНУДИТЕЛЬНОЕ ОБНОВЛЕНИЕ REACT СОСТОЯНИЯ
    const reactFiber = this.getReactFiber(searchInput);
    if (reactFiber) {
      let component = reactFiber;
      while (component) {
        if (component.stateNode && typeof component.stateNode.setState === 'function') {
          try {
            console.log('🔧 Принудительно показываем dropdown через setState');
            component.stateNode.setState({ 
              showDropdown: true,
              query: searchInput.value 
            });
            await this.delay(1000);
            break;
          } catch (error) {
            console.log('⚠️ Ошибка setState:', error.message);
          }
        }
        component = component.return;
      }
    }
    
    // ✅ МНОЖЕСТВЕННЫЕ СОБЫТИЯ ДЛЯ АКТИВАЦИИ DROPDOWN
    const events = ['focus', 'focusin', 'click', 'mousedown', 'input'];
    
    for (const eventType of events) {
      try {
        searchInput.focus();
        this.dispatchReactEvent(searchInput, eventType);
        await this.delay(200);
      } catch (error) {
        console.log(`⚠️ Ошибка события ${eventType}:`, error.message);
      }
    }
    
    this.forceReactUpdate(searchInput);
    await this.delay(1000);
    
    const dropdown = document.querySelector('.geosearch-dropdown, .demo-search-dropdown');
    if (dropdown) {
      console.log('✅ Dropdown успешно показан!');
    } else {
      console.log('⚠️ Dropdown всё ещё не виден');
    }
  }

  dispatchReactEvent(element, eventType, eventData = {}) {
    const reactFiber = this.getReactFiber(element);
    
    if (reactFiber) {
      console.log(`🔧 Найден React fiber для ${eventType}`);
    }
    
    const event = new Event(eventType, {
      bubbles: true,
      cancelable: true,
      ...eventData
    });
    
    Object.defineProperty(event, 'target', {
      value: element,
      enumerable: true
    });
    
    Object.defineProperty(event, 'currentTarget', {
      value: element,
      enumerable: true
    });
    
    element.dispatchEvent(event);
  }

  async dispatchReactInputEvent(element, char) {
    const nativeInputEvent = new InputEvent('input', {
      bubbles: true,
      cancelable: false,
      composed: true,
      data: char,
      inputType: 'insertText',
      isComposing: false
    });
    
    Object.defineProperty(nativeInputEvent, 'target', {
      value: element,
      enumerable: true
    });
    
    Object.defineProperty(nativeInputEvent, 'currentTarget', {
      value: element,
      enumerable: true
    });
    
    element.dispatchEvent(nativeInputEvent);
    
    await this.delay(10);
    
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true
    });
    
    Object.defineProperty(changeEvent, 'target', {
      value: element,
      enumerable: true
    });
    
    element.dispatchEvent(changeEvent);
    
    await this.delay(10);
  }

  async dispatchFinalReactEvents(searchInput) {
    const finalInput = new InputEvent('input', {
      bubbles: true,
      cancelable: false,
      composed: true,
      inputType: 'insertText'
    });
    
    Object.defineProperty(finalInput, 'target', {
      value: searchInput,
      enumerable: true
    });
    
    searchInput.dispatchEvent(finalInput);
    await this.delay(50);
    
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true
    });
    
    Object.defineProperty(changeEvent, 'target', {
      value: searchInput,
      enumerable: true
    });
    
    searchInput.dispatchEvent(changeEvent);
    await this.delay(50);
    
    searchInput.blur();
    await this.delay(10);
    searchInput.focus();
    await this.delay(50);
    
    const events = ['propertychange', 'textInput', 'keyup'];
    
    for (const eventType of events) {
      try {
        const event = new Event(eventType, {
          bubbles: true,
          cancelable: true
        });
        
        Object.defineProperty(event, 'target', {
          value: searchInput,
          enumerable: true
        });
        
        searchInput.dispatchEvent(event);
        await this.delay(10);
      } catch (error) {
        // Игнорируем ошибки
      }
    }
  }

  forceReactUpdate(element) {
    try {
      const reactFiber = this.getReactFiber(element);
      if (reactFiber) {
        let fiberNode = reactFiber;
        while (fiberNode) {
          if (fiberNode.stateNode && typeof fiberNode.stateNode.forceUpdate === 'function') {
            console.log('🔧 Принудительное обновление React компонента');
            fiberNode.stateNode.forceUpdate();
            break;
          }
          fiberNode = fiberNode.return;
        }
      }
      
      if (window.React && window.React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) {
        console.log('🔧 Используем React internals для обновления');
      }
      
      if (element._valueTracker) {
        element._valueTracker.setValue('');
      }
      
    } catch (error) {
      console.log('⚠️ Не удалось принудительно обновить React:', error.message);
    }
  }

  getReactFiber(element) {
    const fiberKey = Object.keys(element).find(key => 
      key.startsWith('__reactInternalInstance$') || 
      key.startsWith('__reactFiber$')
    );
    
    if (fiberKey) {
      return element[fiberKey];
    }
    
    if (element._reactInternalInstance) {
      return element._reactInternalInstance;
    }
    
    return null;
  }

  // ✅ ИСПРАВЛЕННАЯ ПРОВЕРКА РЕЗУЛЬТАТОВ
  async checkForResults() {
    const primarySelectors = [
      '.geosearch-dropdown',
      '.demo-search-dropdown'
    ];
    
    for (const selector of primarySelectors) {
      const container = document.querySelector(selector);
      if (container) {
        const style = window.getComputedStyle(container);
        const isVisible = style.display !== 'none' && 
                         style.visibility !== 'hidden' && 
                         style.opacity !== '0' &&
                         container.offsetHeight > 0 &&
                         container.offsetWidth > 0;
        
        if (isVisible && container.children.length > 0) {
          console.log(`🔍 Найден видимый dropdown: ${selector} (${container.children.length} детей)`);
          
          Array.from(container.children).forEach((child, index) => {
            console.log(`  Ребёнок ${index + 1}: ${child.className} - "${child.textContent.trim().substring(0, 50)}"`);
          });
          
          return true;
        }
      }
    }
    
    const itemSelectors = [
      '.geosearch-dropdown-item',
      '.demo-search-dropdown-item'
    ];
    
    let visibleItems = 0;
    
    for (const selector of itemSelectors) {
      const items = document.querySelectorAll(selector);
      items.forEach(item => {
        const style = window.getComputedStyle(item);
        const isVisible = style.display !== 'none' && 
                         style.visibility !== 'hidden' && 
                         style.opacity !== '0' &&
                         item.offsetHeight > 0 &&
                         item.offsetWidth > 0;
        
        if (isVisible) {
          visibleItems++;
          console.log(`🔍 Найден видимый item: ${selector} - "${item.textContent.trim().substring(0, 50)}"`);
        }
      });
    }
    
    if (visibleItems > 0) {
      console.log(`✅ Найдено ${visibleItems} видимых результатов`);
      return true;
    }
    
    console.log('⚠️ Видимые результаты не найдены');
    return false;
  }

  // ✅ ОЖИДАНИЕ РЕЗУЛЬТАТОВ С УВЕЛИЧЕННОЙ ЗАДЕРЖКОЙ
  async waitForSearchResults() {
    console.log(`⏳ Ожидание результатов поиска (${this.settings.searchDelay}мс)...`);
    
    await this.delay(this.settings.searchDelay);
    
    let attempts = 0;
    const maxAttempts = 50;
    
    while (attempts < maxAttempts && this.isRunning) {
      const debugInfo = await this.debugSearchElements();
      
      if (debugInfo.hasResults) {
        console.log(`✅ Результаты найдены на попытке ${attempts + 1}`);
        console.log(debugInfo.summary);
        return true;
      }
      
      if (attempts % 5 === 0) {
        console.log(`🔍 Попытка ${attempts + 1}/${maxAttempts}: ${debugInfo.summary}`);
        
        await this.forceDropdownShow();
      }
      
      await this.delay(500);
      attempts++;
    }
    
    console.warn('⚠️ Результаты поиска не найдены после всех попыток');
    
    const finalDebug = await this.debugSearchElements();
    console.log('🔍 Финальное состояние DOM:', finalDebug);
    
    return false;
  }

  async debugSearchElements() {
    const searchInput = await this.findSearchInput();
    const inputValue = searchInput ? searchInput.value : 'НЕ НАЙДЕНО';
    
    const containers = [
      '.geosearch-dropdown',
      '.demo-search-dropdown',
      '.demo-search-container .geosearch-dropdown',
      '.demo-search-container .demo-search-dropdown',
      '.demo-search-container .search-results',
      '.search-results',
      '.maplibregl-popup',
      '.suggestions'
    ];
    
    let hasResults = false;
    let visibleResults = 0;
    let foundContainers = [];
    
    for (const selector of containers) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        elements.forEach((element, index) => {
          const style = window.getComputedStyle(element);
          const isVisible = style.display !== 'none' && 
                           style.visibility !== 'hidden' && 
                           style.opacity !== '0';
          
          const childCount = element.children.length;
          
          foundContainers.push({
            selector: selector,
            index: index,
            isVisible: isVisible,
            childCount: childCount,
            text: element.textContent.trim().substring(0, 100)
          });
          
          if (isVisible && childCount > 0) {
            hasResults = true;
            visibleResults += childCount;
          }
        });
      }
    }
    
    const dropdownItems = document.querySelectorAll('.geosearch-dropdown-item, .demo-search-dropdown-item');
    let visibleItems = 0;
    
    dropdownItems.forEach(item => {
      const style = window.getComputedStyle(item);
      const isVisible = style.display !== 'none' && 
                       style.visibility !== 'hidden' && 
                       style.opacity !== '0';
      if (isVisible) {
        visibleItems++;
      }
    });
    
    if (visibleItems > 0) {
      hasResults = true;
    }
    
    const summary = `Поле: "${inputValue}" | Контейнеры: ${foundContainers.length} | Видимые результаты: ${visibleResults} | dropdown-item: ${visibleItems}`;
    
    return {
      hasResults,
      inputValue,
      foundContainers,
      visibleResults,
      visibleItems,
      summary
    };
  }

  findSearchResults() {
    const selectors = [
      '.geosearch-dropdown',
      '.demo-search-dropdown',
      '.demo-search-container .geosearch-dropdown',
      '.demo-search-container .demo-search-dropdown',
      '.demo-search-container .search-results',
      '.search-results',
      '.maplibregl-popup',
      '.suggestions'
    ];
    
    for (const selector of selectors) {
      const container = document.querySelector(selector);
      if (container && container.children.length > 0) {
        console.log(`🔍 Найден контейнер результатов: ${selector} (${container.children.length} результатов)`);
        return container;
      }
    }
    
    console.warn('⚠️ Контейнер результатов не найден');
    return null;
  }

  async clickFirstResult() {
    console.log('🎯 Поиск первого результата...');
    
    let resultsContainer = null;
    let attempts = 0;
    const maxAttempts = 20;
    
    while (!resultsContainer && attempts < maxAttempts && this.isRunning) {
      resultsContainer = this.findSearchResults();
      
      if (!resultsContainer) {
        console.log(`🔍 Попытка ${attempts + 1}/${maxAttempts}: результаты не найдены, ждем...`);
        await this.delay(300);
        attempts++;
      }
    }
    
    if (!resultsContainer) {
      console.warn('⚠️ Контейнер результатов так и не найден');
      return null;
    }
    
    const firstResult = resultsContainer.querySelector('.geosearch-dropdown-item:first-child') ||
                       resultsContainer.querySelector('.demo-search-dropdown-item:first-child') ||
                       resultsContainer.querySelector('.geosearch-dropdown-item') ||
                       resultsContainer.querySelector('.demo-search-dropdown-item') ||
                       resultsContainer.querySelector('.search-result:first-child') ||
                       resultsContainer.querySelector('.suggestion:first-child') ||
                       resultsContainer.querySelector('li:first-child') ||
                       resultsContainer.children[0];
    
    if (!firstResult) {
      console.warn('⚠️ Первый результат не найден в контейнере');
      console.log('📋 Доступные элементы:', Array.from(resultsContainer.children).map(el => el.className));
      return null;
    }
    
    console.log(`🎯 Найден первый результат: "${firstResult.textContent.trim()}" (класс: ${firstResult.className})`);
    
    await this.delay(1200);
    
    const placeData = this.extractPlaceData(firstResult);
    console.log('📊 Извлеченные данные места:', placeData);
    
    try {
      firstResult.click();
      
      setTimeout(() => {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        firstResult.dispatchEvent(clickEvent);
      }, 150);
      
      console.log('✅ Клик выполнен на первый результат');
      
    } catch (error) {
      console.error('❌ Ошибка при клике:', error);
    }
    
    await this.delay(1500);
    
    return placeData;
  }

  extractPlaceData(element) {
    const text = element.textContent.trim();
    console.log(`📊 Извлечение данных из элемента: "${text}"`);
    
    if (element.dataset.lat && element.dataset.lng) {
      const lng = parseFloat(element.dataset.lng);
      const lat = parseFloat(element.dataset.lat);
      
      if (!isNaN(lng) && !isNaN(lat)) {
        const data = {
          name: element.dataset.name || text,
          coordinates: [lng, lat],
          region: element.dataset.region || '',
          country: element.dataset.country || '',
          query: text
        };
        console.log('✅ Данные найдены в dataset:', data);
        return data;
      }
    }
    
    const lat = element.getAttribute('data-lat') || element.getAttribute('lat');
    const lng = element.getAttribute('data-lng') || element.getAttribute('lng') || element.getAttribute('lon');
    
    if (lat && lng) {
      const parsedLng = parseFloat(lng);
      const parsedLat = parseFloat(lat);
      
      if (!isNaN(parsedLng) && !isNaN(parsedLat)) {
        const data = {
          name: text,
          coordinates: [parsedLng, parsedLat],
          region: '',
          country: '',
          query: text
        };
        console.log('✅ Данные найдены в атрибутах:', data);
        return data;
      }
    }
    
    const coordMatch = text.match(/(-?\d+\.?\d*),\s*(-?\d+\.?\d*)/);
    if (coordMatch) {
      const parsedLng = parseFloat(coordMatch[2]);
      const parsedLat = parseFloat(coordMatch[1]);
      
      if (!isNaN(parsedLng) && !isNaN(parsedLat)) {
        const data = {
          name: text.replace(coordMatch[0], '').trim(),
          coordinates: [parsedLng, parsedLat],
          region: '',
          country: '',
          query: text
        };
        console.log('✅ Данные найдены в тексте:', data);
        return data;
      }
    }
    
    const nestedCoords = element.querySelector('[data-lat], [data-lng]');
    if (nestedCoords) {
      const nestedLat = nestedCoords.getAttribute('data-lat') || nestedCoords.getAttribute('lat');
      const nestedLng = nestedCoords.getAttribute('data-lng') || nestedCoords.getAttribute('lng');
      
      if (nestedLat && nestedLng) {
        const parsedLng = parseFloat(nestedLng);
        const parsedLat = parseFloat(nestedLat);
        
        if (!isNaN(parsedLng) && !isNaN(parsedLat)) {
          const data = {
            name: text,
            coordinates: [parsedLng, parsedLat],
            region: '',
            country: '',
            query: text
          };
          console.log('✅ Данные найдены во вложенных элементах:', data);
          return data;
        }
      }
    }
    
    const mockCoordinates = this.getMockCoordinatesForQuery(text);
    if (mockCoordinates) {
      console.log('✅ Используются мокк-координаты:', mockCoordinates);
      return mockCoordinates;
    }
    
    console.warn('⚠️ Координаты не найдены, возвращаем только название');
    return {
      name: text,
      coordinates: null,
      region: '',
      country: '',
      query: text
    };
  }

  getMockCoordinatesForQuery(query) {
    const q = query.toLowerCase();
    
    if (q.includes('rockefeller') || q.includes('30 rockefeller')) {
      return {
        name: query,
        coordinates: [-73.9787, 40.7589],
        region: 'New York',
        country: 'USA',
        query: query
      };
    }
    
    if (q.includes('baker street') || q.includes('221b')) {
      return {
        name: query,
        coordinates: [-0.1586, 51.5238],
        region: 'London',
        country: 'UK',
        query: query
      };
    }
    
    if (q.includes('trafalgar square')) {
      return {
        name: query,
        coordinates: [-0.1278, 51.5080],
        region: 'London',
        country: 'UK',
        query: query
      };
    }
    
    if (q.includes('new york') && !q.includes('plaza')) {
      return {
        name: query,
        coordinates: [-74.0060, 40.7128],
        region: 'New York',
        country: 'USA',
        query: query
      };
    }
    
    if (q.includes('miami')) {
      return {
        name: query,
        coordinates: [-80.1918, 25.7617],
        region: 'Florida',
        country: 'USA',
        query: query
      };
    }
    
    if (q.includes('madrid')) {
      return {
        name: query,
        coordinates: [-3.7038, 40.4168],
        region: 'Madrid',
        country: 'Spain',
        query: query
      };
    }
    
    if (q.includes('berlin')) {
      return {
        name: query,
        coordinates: [13.4050, 52.5200],
        region: 'Berlin',
        country: 'Germany',
        query: query
      };
    }
    
    if (q.includes('france')) {
      return {
        name: query,
        coordinates: [2.2137, 46.2276],
        region: 'France',
        country: 'France',
        query: query
      };
    }
    
    if (q.includes('united kingdom') || q.includes('uk')) {
      return {
        name: query,
        coordinates: [-3.4360, 55.3781],
        region: 'United Kingdom',
        country: 'UK',
        query: query
      };
    }
    
    return null;
  }

  async flyToLocation(place) {
    if (!place) {
      console.warn('⚠️ Место не определено для пролета');
      return;
    }
    
    if (!place.coordinates || !Array.isArray(place.coordinates) || place.coordinates.length < 2) {
      console.warn(`⚠️ Нет валидных координат для пролета к: ${place.name}`);
      return;
    }
    
    const [lng, lat] = place.coordinates;
    if (typeof lng !== 'number' || typeof lat !== 'number' || isNaN(lng) || isNaN(lat)) {
      console.warn(`⚠️ Некорректные координаты для: ${place.name} [${lng}, ${lat}]`);
      return;
    }
    
    console.log(`✈️ Пролет к: ${place.name} [${lat}, ${lng}]`);
    
    let zoom = 15;
    let pitch = 45;
    let bearing = Math.random() * 360;
    
    const placeName = place.name.toLowerCase();
    
    if (placeName.includes('rockefeller') || placeName.includes('30 rockefeller')) {
      zoom = 13.5; pitch = 50;
    } else if (placeName.includes('street') || placeName.includes('avenue') || placeName.includes('plaza')) {
      zoom = 16; pitch = 55;
    } else if (placeName.includes('square') || placeName.includes('park') || placeName.includes('station')) {
      zoom = 15.5; pitch = 50;
    } else if (placeName.match(/^(new york|miami|madrid|berlin)$/i)) {
      zoom = 11; pitch = 30;
    } else if (placeName.match(/^(france|united kingdom)$/i)) {
      zoom = 6; pitch = 0;
    }
    
    return new Promise((resolve) => {
      try {
        this.map.flyTo({
          center: [lng, lat],
          zoom: zoom,
          pitch: pitch,
          bearing: bearing,
          duration: this.settings.flightDuration,
          essential: true,
          curve: 1.42,
          speed: 0.6
        });
        
        setTimeout(resolve, this.settings.flightDuration + 500);
        
      } catch (error) {
        console.error('❌ Ошибка пролета к локации:', error);
        resolve();
      }
    });
  }

  async transitionToNext() {
    console.log('🔄 Медленный переход к следующей локации...');
    
    try {
      const currentCenter = this.map.getCenter();
      const currentZoom = this.map.getZoom();
      
      this.map.flyTo({
        center: currentCenter,
        zoom: Math.max(currentZoom - 5, 2),
        pitch: 0,
        bearing: 0,
        duration: this.settings.transitionTime * 2,
        essential: true,
        curve: 1.42,
        speed: 0.4
      });
      
      await this.delay(this.settings.transitionTime * 2.2);
      
    } catch (error) {
      console.error('❌ Ошибка в переходе:', error);
    }
  }

  async createFinalTransition() {
    console.log('🎬 Создание медленного финального перехода...');
    
    if (this.visitedLocations.length === 0) {
      console.warn('⚠️ Нет посещенных локаций для финального перехода');
      return;
    }
    
    const validLocations = this.visitedLocations.filter(loc => 
      loc.place && 
      loc.place.coordinates && 
      Array.isArray(loc.place.coordinates) && 
      loc.place.coordinates.length >= 2 &&
      typeof loc.place.coordinates[0] === 'number' &&
      typeof loc.place.coordinates[1] === 'number'
    );
    
    if (validLocations.length === 0) {
      console.warn('⚠️ Нет локаций с валидными координатами для финального перехода');
      return;
    }
    
    const firstLocation = validLocations[0];
    const lastLocation = validLocations[validLocations.length - 1];
    
    console.log(`🎬 Финальный переход: ${firstLocation.place.name} → ${lastLocation.place.name}`);
    
    try {
      this.map.flyTo({
        center: [
          (firstLocation.place.coordinates[0] + lastLocation.place.coordinates[0]) / 2,
          (firstLocation.place.coordinates[1] + lastLocation.place.coordinates[1]) / 2
        ],
        zoom: 2,
        pitch: 0,
        bearing: 0,
        duration: 5000,
        essential: true,
        curve: 1.42,
        speed: 0.4
      });
      
      await this.delay(5500);
      
      await this.flyToLocation(firstLocation.place);
      
    } catch (error) {
      console.error('❌ Ошибка в финальном переходе:', error);
    }
  }

  stopVideoRecording() {
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop();
      this.isRecording = false;
      console.log('⏹️ Запись canvas карты остановлена');
    }
  }

  saveVideoFile(quality) {
    if (this.recordedChunks.length === 0) return;

    const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
    const sizeMB = (blob.size / (1024 * 1024)).toFixed(1);
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    a.href = url;
    a.download = `canvas-auto-search-tour-${quality}-${this.visitedLocations.length}places-${timestamp}.webm`;
    
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    console.log(`💾 Видео canvas карты сохранено: ${sizeMB} МБ (${this.visitedLocations.length} мест)`);
    this.showSaveNotification(`🤖 Canvas карты (${this.visitedLocations.length} мест): ${sizeMB} МБ`);
  }

  hideRecordingIndicator() {
    const indicator = document.getElementById('video-recording-indicator');
    if (indicator) indicator.remove();
    
    const progress = document.getElementById('video-progress-indicator');
    if (progress) progress.remove();
    
    const status = document.getElementById('typing-status');
    if (status) status.remove();
    
    const style = document.getElementById('recording-animation');
    if (style) style.remove();
  }

  showUIElements() {
    if (this.hiddenElements) {
      this.hiddenElements.forEach(({element, originalDisplay}) => {
        element.style.display = originalDisplay;
      });
      console.log(`👁️ Восстановлено ${this.hiddenElements.length} элементов`);
      this.hiddenElements = [];
    }
  }

  showSaveNotification(message) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20000;
      background: #34C759;
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      font-weight: bold;
      box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    `;
    notification.innerHTML = `💾 ${message}`;
    document.body.appendChild(notification);
    
    setTimeout(() => notification.remove(), 4000);
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  stop() {
    console.log('⏹️ Остановка автопоиска');
    this.isRunning = false;
    this.stopCaching();
    
    if (this.isRecording) {
      this.hideRecordingIndicator();
      this.stopVideoRecording();
      setTimeout(() => {
        this.showUIElements();
      }, 1000);
    }
  }

  getStats() {
    return {
      isRunning: this.isRunning,
      isRecording: this.isRecording,
      isCaching: this.isCaching,
      isCached: this.isCached,
      currentIndex: this.currentLocationIndex,
      totalLocations: this.searchLocations.length,
      visitedCount: this.visitedLocations.length,
      visitedLocations: this.visitedLocations.map(v => v.place.name)
    };
  }
}

// 🎮 КОНТРОЛЛЕР
class AutoSearchController {
  constructor(map) {
    this.autoSearch = new AutoSearchShowcase(map);
    this.createControls();
    this.setupKeyboardControls();
  }

  createControls() {
    const existingControls = document.getElementById('auto-search-controls');
    if (existingControls) {
      existingControls.remove();
    }

    const controlsDiv = document.createElement('div');
    controlsDiv.id = 'auto-search-controls';
    controlsDiv.style.cssText = `
      position: absolute;
      bottom: 20px;
      right: 20px;
      z-index: 1000;
      background: rgba(0,0,0,0.9);
      padding: 15px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 280px;
    `;
    
    controlsDiv.innerHTML = `
      <div style="color: white; font-size: 13px; font-weight: bold; text-align: center; margin-bottom: 8px;">
        🤖 Запись canvas карты
      </div>
      
      <div style="color: #888; font-size: 10px; text-align: center; margin-bottom: 8px;">
        Сначала кэшируй → потом записывай canvas
      </div>
      
      <div style="display: flex; gap: 6px; margin-bottom: 4px;">
        <button id="pre-cache" style="background: #FF9500; color: white; border: none; padding: 10px 15px; border-radius: 5px; cursor: pointer; font-size: 12px; flex: 1; font-weight: bold;">
          🗄️ Кэширование (Ctrl+Shift+C)
        </button>
        <button id="stop-cache" style="background: #8E8E93; color: white; border: none; padding: 10px 15px; border-radius: 5px; cursor: pointer; font-size: 12px;">
          ⏹️
        </button>
      </div>
      
      <div style="height: 1px; background: #333; margin: 4px 0;"></div>
      
      <div style="display: flex; gap: 6px;">
        <button id="auto-mobile" style="background: #34C759; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px; flex: 1;">
          📱 Мини (1)
        </button>
        <button id="auto-web" style="background: #007AFF; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px; flex: 1;">
          🌐 Веб (2)
        </button>
      </div>
      
      <div style="display: flex; gap: 6px;">
        <button id="auto-hd" style="background: #AF52DE; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px; flex: 1;">
          🎬 HD (3)
        </button>
        <button id="auto-stop" style="background: #FF453A; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px;">
          ⏹️ Стоп
        </button>
      </div>
      
      <div style="font-size: 9px; color: #666; text-align: center; margin-top: 5px;">
        Кэш готов? <span id="cache-status" style="color: #FF453A;">❌ НЕТ</span>
      </div>
    `;
    
    document.body.appendChild(controlsDiv);
    
    document.getElementById('pre-cache').addEventListener('click', () => {
      this.autoSearch.startPreCaching();
    });
    
    document.getElementById('stop-cache').addEventListener('click', () => {
      this.autoSearch.stopCaching();
    });
    
    document.getElementById('auto-mobile').addEventListener('click', () => {
      this.autoSearch.startAutoSearchTour('mobile');
    });
    
    document.getElementById('auto-web').addEventListener('click', () => {
      this.autoSearch.startAutoSearchTour('web');
    });
    
    document.getElementById('auto-hd').addEventListener('click', () => {
      this.autoSearch.startAutoSearchTour('hd');
    });
    
    document.getElementById('auto-stop').addEventListener('click', () => {
      this.autoSearch.stop();
    });

    setInterval(() => {
      this.updateCacheStatus();
    }, 1000);
  }

  updateCacheStatus() {
    const statusEl = document.getElementById('cache-status');
    if (statusEl) {
      const stats = this.autoSearch.getStats();
      if (stats.isCaching) {
        statusEl.innerHTML = '🗄️ КЭШИРОВАНИЕ...';
        statusEl.style.color = '#FF9500';
      } else if (stats.isCached) {
        statusEl.innerHTML = '✅ ГОТОВ';
        statusEl.style.color = '#34C759';
      } else {
        statusEl.innerHTML = '❌ НЕТ';
        statusEl.style.color = '#FF453A';
      }
    }
  }

  setupKeyboardControls() {
    document.addEventListener('keydown', (event) => {
      if (event.key.toLowerCase() === 'c' && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        this.autoSearch.startPreCaching();
        console.log('🗄️ Запуск предварительного кэширования (Ctrl+Shift+C)');
      }
      
      if (event.key === '1' && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        this.autoSearch.startAutoSearchTour('mobile');
        console.log('🤖📱 Запись canvas: Мобильная (Ctrl+Shift+1)');
      }
      
      if (event.key === '2' && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        this.autoSearch.startAutoSearchTour('web');
        console.log('🤖🌐 Запись canvas: Веб (Ctrl+Shift+2)');
      }
      
      if (event.key === '3' && event.ctrlKey && event.shiftKey) {
        event.preventDefault();
        this.autoSearch.startAutoSearchTour('hd');
        console.log('🤖🎬 Запись canvas: HD (Ctrl+Shift+3)');
      }
      
      if (event.key === 'Escape') {
        this.autoSearch.stop();
      }
    });
    
    console.log('⌨️ Горячие клавиши автопоиска:');
    console.log('   Ctrl+Shift+C - Предварительное кэширование');
    console.log('   Ctrl+Shift+1 - Мобильная запись canvas');
    console.log('   Ctrl+Shift+2 - Веб запись canvas');
    console.log('   Ctrl+Shift+3 - HD запись canvas');
    console.log('   ESC - Остановка');
    console.log('');
    console.log('🤖 ЗАПИСЬ CANVAS КАРТЫ ГОТОВА!');
    console.log('   1️⃣ Сначала нажми "Кэширование"');
    console.log('   2️⃣ Дождись ✅ ГОТОВ');
    console.log('   3️⃣ Запускай запись!');
  }
}

export { AutoSearchShowcase, AutoSearchController };